import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import Layout from './components/layout/Layout';
import HomePage from './components/pages/HomePage';
import DataCleaningPage from './components/pages/DataCleaningPage';
import DataAugmentationPage from './components/pages/DataAugmentationPage';
import PreprocessingPage from './components/pages/PreprocessingPage';
import NotFoundPage from './components/pages/NotFoundPage';
import './styles/global.css'; 
import Privacy from './components/pages/Privacy';
import About from './components/pages/About';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <NotificationProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route 
                path="/data-cleaning" 
                element={
                  <ErrorBoundary>
                    <DataCleaningPage />
                  </ErrorBoundary>
                } 
              />
              <Route 
                path="/privacy" 
                element={
                  <Privacy />
                } 
              />
              <Route 
                path="/about" 
                element={
                  <About />
                } 
              />
              <Route 
                path="/data-augmentation" 
                element={
                  <ErrorBoundary>
                    <DataAugmentationPage />
                  </ErrorBoundary>
                } 
              />
              <Route 
                path="/preprocessing" 
                element={
                  <ErrorBoundary>
                    <PreprocessingPage />
                  </ErrorBoundary>
                } 
              />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </Router>
      </NotificationProvider>
    </ErrorBoundary>
  );
};

export default App;